import styled, { css } from 'styled-components';

export const DivText = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    max-width: 390px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-width: 100%;
      text-align: center;
      margin: 0 auto 16px auto;
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
      color: #21759B;
      font-family: ${theme.v2.font.family.primary};
      font-size: 20px;
      font-weight: ${theme.v2.font.weights.medium};
      line-height: 1.5;
      max-width: 340px;
      margin: 0px;

      @media (max-width: ${theme.v2.breakpoints.sm}) {
        font-size: ${theme.v2.font.sizes.sm2};
      }

      strong {
        font-weight: 500;
      }
  `}
`;

export const Subtitle = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryBlue};
    font-family: ${theme.v2.font.family.primary};
    font-size: 28px;
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 140%;
    margin: 0px 0px 20px 0px;
    max-width: 350px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
      max-width: 100%;
      margin: 0 auto 16px auto;
    }
  `}
`;

export const Description = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 140%;
    margin: 0px 0px 24px 0px;
  `}
`;

export const ButtonWrapper = styled.div`
 ${({ theme }) => css`
    display: flex;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      order: 2;
      width: 100%;
      max-width: 100%;
    }
 `}
`;

export const WrapperTitle = styled.div`
 ${({ theme }) => css`
  align-items: center;
  display: flex;
  gap: 6px;
  justify-content: center;
  margin: 0px 0px 16px 0px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 0 auto 16px auto;
    }
  `}
`;
